const overrideUtil = function (Vue) {
  this.compoList = Vue._context.components;
  this.toCamel = function (name) {
    name = name
      .split('-')
      .map(v => v[0].toUpperCase() + v.slice(1))
      .join('');
    name = name[0].toLowerCase() + name.slice(1);
    return name;
  };
  this.toKebab = function (name) {
    name = name
      .split(/(?=[A-Z])/)
      .map(v => v.toLowerCase())
      .join('-');
    return name;
  };
  this.findCompo = function (compoName) {
    if (typeof this.compoList[compoName] === 'object') {
      return compoName;
    }
    if (compoName.includes('-')) {
      compoName = this.toCamel(compoName);
      if (typeof this.compoList[compoName] === 'object') {
        return compoName; // exist in camel-case
      }
      return ''; // not exist
    }
    compoName = this.toKebab(compoName);
    if (typeof this.compoList[compoName] === 'object') {
      return compoName; // exist in kebab-case
    }
    return ''; // not exist
  };
  this.extend = function (componentName, component, newCompoName) {
    let compoName = this.findCompo(componentName);
    if (!compoName) {
      console.error('[LEGO-COMPONENT-EXTEND] Component which does not exist cannot be overridden');
    } else {
      Vue.component(
        newCompoName || compoName,
        Object.assign(component, { extends: this.compoList[compoName] }),
      );
    }
  };
  this.wrapping = function (componentName, component, newCompoName, originalCompoName) {
    newCompoName = this.toKebab(newCompoName);
    originalCompoName = this.toKebab(originalCompoName);
    let compoName = this.findCompo(componentName);
    if (!compoName) {
      console.error(
        '[LEGO-COMPONENT-WRAPPING] Component which does not exist cannot be overridden',
      );
    } else {
      let componentUse = {},
        innerName = '';
      Vue.component(originalCompoName, this.compoList[compoName]);
      componentUse[originalCompoName] = this.compoList[originalCompoName];
      innerName = newCompoName === originalCompoName ? 'dummy-name' : newCompoName;
      Vue.component(
        newCompoName,
        Object.assign(component, { name: innerName, components: componentUse }),
      );
    }
  };
};

export default overrideUtil;
